// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"4316":"ad2866b8","4628":"b645e135"}[chunkId] + "." + {"4316":"da7517a88118b074","4628":"f3c7d059934e3bdd"}[chunkId] + ".js";
};